<template lang="pug">
.error-page
  .error-card
    .error-icon
      i(:class="icon")
    p.error-code(v-if="code") {{ code }}
    h1.error-title {{ title }}
    p.error-message(v-if="message") {{ message }}
    .error-actions
      Button(
        icon="pi pi-home"
        label="Ir al inicio"
        @click="goHome"
      )
      Button(
        icon="pi pi-arrow-left"
        label="Volver"
        severity="secondary"
        outlined
        @click="goBack"
      )
</template>

<script>
/**
 * Página de error a pantalla completa (404, sin permisos).
 *
 * Antes estos casos se resolvían con un h('div', 'texto') declarado
 * dentro del router: llegaban al usuario como una línea de texto suelta
 * sobre fondo blanco, sin layout ni forma de volver a ninguna parte.
 */
export default {
  name: 'ErrorPage',
  props: {
    /** Código a mostrar, ej: '404'. Opcional. */
    code: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'pi pi-compass',
    },
  },
  methods: {
    goHome() {
      this.$router.push('/');
    },
    goBack() {
      // Si se entró directo por URL no hay historial al que volver.
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.goHome();
      }
    },
  },
};
</script>

<style scoped>
.error-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: var(--escality-content-bg);
}

.error-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 32rem;
  padding: 3rem 2rem;
  background: var(--escality-surface);
  border: 1px solid var(--escality-gray-200);
  border-radius: var(--escality-radius-lg);
  box-shadow: var(--escality-shadow-md);
}

.error-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: var(--escality-radius-full);
  background: var(--escality-primary-50);
  color: var(--escality-primary);
  font-size: 1.75rem;
}

.error-code {
  margin: 1rem 0 0;
  font-family: var(--escality-heading-family);
  font-weight: var(--escality-font-weight-bold);
  font-size: var(--escality-text-sm);
  letter-spacing: 0.08em;
  color: var(--escality-gray-400);
}

.error-title {
  margin: 0.25rem 0 0;
  font-size: var(--escality-text-xl);
}

.error-message {
  margin: 0.5rem 0 0;
  font-size: var(--escality-text-md);
  color: var(--escality-gray-500);
}

.error-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 1.75rem;
}
</style>
